import React from 'react'

interface FilterSelectProps {
 label: string
 value: string
 onChange: (value: string) => void
 options: Array<{ value: string; label: string }>
 placeholder?: string
 disabled?: boolean
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
 label,
 value,
 onChange,
 options,
 placeholder = 'Selecione...',
 disabled = false
}) => {
 return (
 <div className="space-y-2">
 <label className="block text-sm font-medium text-foreground">
 {label}
 </label>
 <select
 value={value}
 onChange={(e) => onChange(e.target.value)}
 disabled={disabled}
 className="block w-full px-3 py-2 border border-border rounded-md bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent disabled:opacity-50 disabled:cursor-not-allowed text-sm"
 >
 <option value="">{placeholder}</option>
 {options.map((option) => (
 <option key={option.value} value={option.value}>
 {option.label}
 </option>
 ))}
 </select>
 </div>
 )
}

